import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, className = "", y = 32 }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.9, delay, ease: EASE }}
  >
    {children}
  </motion.div>
);

export const MaskedLine = ({ children, delay = 0, className = "", innerClassName = "" }) => (
  <span className={`block overflow-hidden pb-[0.08em] ${className}`}>
    <motion.span
      className={`block ${innerClassName}`}
      initial={{ y: "115%" }}
      animate={{ y: "0%" }}
      transition={{ duration: 1.1, delay, ease: EASE }}
    >
      {children}
    </motion.span>
  </span>
);

export const Eyebrow = ({ children, className = "" }) => (
  <p className={`font-mono text-[11px] uppercase tracking-[0.3em] text-[#8F6B3C] ${className}`}>
    {children}
  </p>
);

export const Marquee = ({ items }) => (
  <div data-testid="editorial-marquee" className="relative overflow-hidden border-y border-stone-300/70 bg-[#F0ECE4] py-5">
    <div className="marquee-track flex w-max items-center gap-10 whitespace-nowrap">
      {[...items, ...items].map((item, i) => (
        <span key={i} className="flex items-center gap-10">
          <span className="font-serif text-2xl italic text-stone-600 md:text-3xl">{item}</span>
          <span className="h-1.5 w-1.5 rotate-45 bg-[#C89D66]" />
        </span>
      ))}
    </div>
  </div>
);

export const PageHero = ({ eyebrow, lines, sub, img }) => (
  <section data-testid="page-hero" className="relative overflow-hidden pb-16 pt-36 md:pb-24 md:pt-44">
    {img && (
      <div className="absolute inset-0">
        <img src={img} alt="" className="h-full w-full object-cover opacity-25" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#F7F5F0] via-[#F7F5F0]/70 to-[#F7F5F0]/40" />
      </div>
    )}
    <div className="relative mx-auto max-w-7xl px-6">
      <Reveal>
        <Eyebrow>{eyebrow}</Eyebrow>
      </Reveal>
      <h1 className="mt-5 font-serif text-4xl uppercase leading-[1.05] tracking-tight text-stone-900 sm:text-5xl lg:text-6xl">
        {lines.map((line, i) => (
          <MaskedLine key={i} delay={0.15 + i * 0.12}>
            {line}
          </MaskedLine>
        ))}
      </h1>
      {sub && (
        <Reveal delay={0.5}>
          <p className="mt-6 max-w-2xl text-base leading-relaxed text-stone-500 md:text-lg">{sub}</p>
        </Reveal>
      )}
    </div>
  </section>
);
